export default [


	// DIKLAT MENU 
	
	{
	  path: "/gap",
	  name: "gap_saya",
	  component: () => import(`@/modules/diklat/users/gap.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/minat",
	  name: "minat",
	  component: () => import(`@/modules/diklat/users/minat.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/diklat/ujikom",
	  name: "ujian_kompetensi",
	  component: () => import(`@/modules/diklat/ujikom.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/diklat/master",
	  name: "master_diklat",
	  component: () => import(`@/modules/diklat/master.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/diklat/gap",
	  name: "gap",
	  component: () => import(`@/modules/diklat/gap_kompetensi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/box",
	  name: "box",
	  component: () => import(`@/modules/box.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/formasi",
	  name: "formasi",
	  component: () => import(`@/modules/formasi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/kosong",
	  name: "kosong",
	  component: () => import(`@/modules/jabatan_kosong.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/promosi",
	  name: "blank",
	  component: () => import(`@/modules/diklat/blank.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/rotasi",
	  name: "blank",
	  component: () => import(`@/modules/diklat/blank.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/simulasi",
	  name: "simulasi",
	  component: () => import(`@/modules/simulasi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/suksesi",
	  name: "suksesi",
	  component: () => import(`@/modules/suksesi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/suksesor",
	  name: "Suksesor",
	  component: () => import(`@/modules/suksesor.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/skoring",
	  name: "skoring",
	  component: () => import(`@/modules/skoring.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/assessment",
	  name: "assessment",
	  component: () => import(`@/modules/assessment.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/kompetensi",
	  name: "kompetensi",
	  component: () => import(`@/modules/kompetensi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/rekonsiliasi",
	  name: "rekonsiliasi",
	  component: () => import(`@/modules/rekonsiliasi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/skema",
	  name: "skema",
	  component: () => import(`@/modules/skema.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/penilai",
	  name: "penilai",
	  component: () => import(`@/modules/penilai.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/stat_kompetensi",
	  name: "stat_kompetensi",
	  component: () => import(`@/modules/stat_kompetensi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/rekomendasi",
	  name: "rekomendasi",
	  component: () => import(`@/modules/rekomendasi.vue`),
	  meta: { layout: "diklat" }
	},
	{
	  path: "/human_capital",
	  name: "human_capital",
	  component: () => import(`@/modules/human_capital.vue`),
	  meta: { layout: "diklat" }
	}
]  


// WEBPACK FOOTER //
// ./src/router/module.js